module.exports = __webpack_public_path__ + "media/images/article-types-doc-8c89c771cd99c96596fab0b6b468d262.png";